import {css, unsafeCSS} from "lit";
import {sbkCoreBreakpointLg} from "@/tokens/variables";

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`

    * {
        box-sizing: border-box;
    }
    
    .repeatable-container {
        margin: 0;
    }

  .form-field {
    position: relative;
      border: none;
      margin: 0;
      padding: 0;
  }
    
    .header {
        display: flex;
        flex-direction: row;
        gap: var(--sbkCoreSpacingXsBase);
        justify-content: space-between;
        margin-bottom: var(--sbkTypographyLargeScrSm);
    }
    
    legend {
        padding: 0;
        max-width: var(--sbkCoreContentAreaTitelMaxWidth);
        font: var(--sbkTypographyContentSmallScrTitleMd);
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkTypographyContentLargeScrTitleMd);
        }
    }

  sbk-modal {
      float: right;
      flex-shrink: 0;
  }

    .button-add {
        margin-bottom: var(--sbkCoreSpacingMd);
    }
`;